import { render } from "./CustomersFeedbackBlock.vue?vue&type=template&id=9bd12b5c&scoped=true&ts=true"
import script from "./CustomersFeedbackBlock.vue?vue&type=script&lang=ts"
export * from "./CustomersFeedbackBlock.vue?vue&type=script&lang=ts"

import "./CustomersFeedbackBlock.vue?vue&type=style&index=0&id=9bd12b5c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd12b5c"]])

export default __exports__